module.exports = __webpack_public_path__ + "img/1578445998.7e1530b1.jpg";